import {Column, HeaderProps} from 'react-table'
import {PropsWithChildren} from 'react'
import {IUser} from './core/_model'
import {CustomHeader} from '../../utils/components/Table/CustomHeader'
import Username from './Username'
import {setUserType} from './core/helper'
import UserKycFormButton from './UserKycFormButton'
import {formatDate} from '../../utils/helperFunction/_helper'
import UserAction from './UserAction'
import SelectionHeader from '../../utils/components/Table/SelectionHeader'
import {UserListSelectContext} from './UserListSelectProvider'
import {SelectionCell} from '../../utils/components/Table/SelectionCell'
import UserInfoCell from './UserInfoCell'
import PaymentCell from './PaymentCell'
import UserStatusCell from './UserStatusCell'
import UserBalanceCell from './UserBalanceCell'

const UserListColumn: ReadonlyArray<Column<IUser>> = [
  {
    Header: (props) => (
      <SelectionHeader tableProps={props as any} context={UserListSelectContext} />
    ),
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id} context={UserListSelectContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
      <CustomHeader tableProps={props} title='User' className='min-w-125px' />
    ),
    id: 'userinfo',
    Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} />,
  },
  // {
  //   Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
  //     <CustomHeader tableProps={props} title='Type' className='min-w-125px' />
  //   ),
  //   id: 'type',
  //   Cell: ({...props}) => <span>{setUserType(props.data[props.row.index].user_profile)}</span>,
  // },
  // {
  //   Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
  //     <CustomHeader tableProps={props} title='Name' className='min-w-125px' />
  //   ),
  //   id: 'name',
  //   Cell: ({...props}) => (
  //     <span>
  //       {props.data[props.row.index].username ? props.data[props.row.index].username : 'Unknown'}
  //     </span>
  //   ),
  // },
  {
    Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
      <CustomHeader tableProps={props} title='Status' className='min-w-125px' />
    ),
    id: 'status',
    accessor: 'user_status',
    Cell: ({...props}) => <UserStatusCell status={props.data[props.row.index].user_status} />,
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
      <CustomHeader tableProps={props} title='Balance' className='min-w-125px' />
    ),
    id: 'balance',
    Cell: ({...props}) => (
      <UserBalanceCell
        balance={props.data[props.row.index].userbalance}
        paymentType={props.data[props.row.index].payment_type}
        creditLimit={props.data[props.row.index].credit_limit}
      />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
      <CustomHeader tableProps={props} title='Payment' className='min-w-200px' />
    ),
    id: 'payment',
    Cell: ({...props}) => (
      <PaymentCell
        paymentType={props.data[props.row.index].payment_type}
        creditLimit={props.data[props.row.index].credit_limit}
      />
    ),
  },
  // {
  //   Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
  //     <CustomHeader tableProps={props} title='Email' className='min-w-125px' />
  //   ),
  //   id: 'email',
  //   accessor: 'user_email',
  // },
  // {
  //   Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
  //     <CustomHeader tableProps={props} title='Contact No' className='min-w-125px' />
  //   ),
  //   id: 'contactNo',
  //   accessor: 'user_mobile',
  // },
  {
    Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
      <CustomHeader tableProps={props} title='KYC Form' className='min-w-125px' />
    ),
    id: 'kycform',
    Cell: ({...props}) => <UserKycFormButton user={props.data[props.row.index]} />,
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
      <CustomHeader tableProps={props} title='Last Recharge Date' className='min-w-200px' />
    ),
    id: 'lastRechargeDate',
    accessor: 'last_recharge_date',
    Cell: ({...props}) => <p>{formatDate(props.data[props.row.index].last_recharge_date)}</p>,
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IUser>>) => (
      <CustomHeader tableProps={props} title='Action' className='min-w-125px text-end' />
    ),
    id: 'action',
    Cell: ({...props}) => <UserAction user={props.data[props.row.index]} />,
  },
]

export {UserListColumn}
